import React from "react";
import "./LoadingScreen.css";

function LoadingScreen() {
  return (
    <div className="loading-container align-middle">
      {/* <div class="loading" data-loading-text="Please Wait..."></div> */}
      <div class="loading loading01">
        <span>L</span>
        <span>O</span>
        <span>A</span>
        <span>D</span>
        <span>I</span>
        <span>N</span>
        <span>G</span>
      </div>
      <div class="spinner-grow text-success" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <div className="planamana">
        <h2>We'r Planning & Managing for you ⚙</h2>
      </div>
    </div>
  );
}

export default LoadingScreen;
